(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name flightWatch.controller:FlightWatchUpdateCtrl
   *
   * @description
   *
   */
  angular
    .module('flightWatch')
    .controller('FlightWatchUpdateCtrl', FlightWatchUpdateCtrl);

  function FlightWatchUpdateCtrl(modalParams, applicationConstants, CommonMasterData, FlightWatch, $uibModalInstance, MessageService, PopupManager, CommonLogicService, EventManagerService, RemoteService, $scope,CrewingSelectionHelper) {
    var vm = this;
    vm.editDisablePax = true;
    vm.approachTypes = modalParams.approachTypes;
    vm.airCraftDetails = modalParams.airCraftDetails;
    vm.airCraftDetails.bookedAdults = vm.airCraftDetails.estimatedNoOfAdultsMale  + vm.airCraftDetails.estimatedNoOfAdultsFemale;
    vm.airCraftDetails.flightDurationInMinutes = angular.copy(vm.airCraftDetails.actualDuration);
    vm.airCraftDetails.actualDuration = CommonLogicService.getHoursByMinutes(vm.airCraftDetails.actualDuration || 0);
    vm.airCraftDetails.flyingDuration = CommonLogicService.getHoursByMinutes(vm.airCraftDetails.flyingDuration || 0);
    vm.airCraftDetails.approachTypeTemp = {approachConCode: ''};
    vm.airCraftDetails.approachConditionTemp = {approachTypeCode: ''};
    validateRegList(vm.airCraftDetails.originalEstimatedDepartureDate, vm.airCraftDetails.originalEstimatedArrivalDate, modalParams.relatedAirCraft);
    vm.tempRelatedAirCraft = modalParams.relatedAirCraft;
    vm.delayCodeDetails = modalParams.delayCodeDetails;
    vm.updateFlightSource = modalParams.updateFlightSource;
    vm.getRelatedAircrafts = '';
    vm.airCraftDetails.continueDiversion = isContinueDiversion();
    vm.airCraftDetails.isDisableDiversion = true;
    vm.airCraftDetails.defueling = null;
    vm.airCraftDetails.leakages = null;
    vm.airCraftDetails.ebsNo = null;
    vm.airCraftDetails.fuelSupplier = null;
    vm.airCraftDetails.fuelInvoiceNo = null;
    vm.airCraftDetails.regUpdated = false;
    vm.airCraftDetails.previousRegId = null;
    vm.fuelSupplies = modalParams.fuelSuppliers;
    vm.slotData = '';
    vm.slotRawDataIsCollapse = [];
    vm.mvtMessageData = null;
    vm.rotationData = modalParams.rotationData;
    vm.newRemarks = [];
    vm.remark = '';
    vm.selectedFlightLegOrigin = modalParams.airCraftDetails.originApt;
    vm.selectedFlightLegDep = modalParams.airCraftDetails.destinationApt;
    vm.flightEditPriviledges = [];
    vm.atcSignSelectedValue = findDefaultRadioValue();
    vm.atcAdhocSignIcon = true;
    vm.atcAdHocCallSign = vm.airCraftDetails.atcAdHocCallSign;
    vm.amadeusServiceEnabled = false;
    vm.amadeusRegUpdated = false;
    vm.connectionFlights = vm.airCraftDetails.connectionFlightList;
    vm.airCraftDetails.requestExtraFuel = false;
    //vm.airCraftDetails.remarksOnExtraFuel = null;
    vm.extraFuelReasons = null;
    vm.operationTypes = [];

    checkAircraftRegistrationUpdateStatus();

    checkFlightEditPriviExist();

    getAirCraftTypes();

    getFlightAssignedCrew();

    loadSlotData();

    isShowMVTMessage();

    loadMVTMessageData();

    if (!!vm.airCraftDetails.currentRegId) {
      vm.airCraftDetails.currentRegId = _.find(vm.relatedAirCraft, {registrationID: vm.airCraftDetails.currentRegId})
      vm.airCraftDetails.previousRegId = vm.airCraftDetails.currentRegId;
    }
    if (!!vm.airCraftDetails.aircraftModel) {
      vm.airCraftDetails.aircraftModel = _.find(vm.aircraftTypes, {modelNumber: vm.airCraftDetails.aircraftModel})
    }

    vm.airCraftDetails.assignedCrew = '';

    vm.airports = modalParams.airports;

    if (!!vm.airCraftDetails.departureDiversionAptCode) {
      vm.airCraftDetails.departureDiversionAptCode = _.find(vm.airports, {airPortCode: vm.airCraftDetails.departureDiversionAptCode})
    }
    else {
      vm.airCraftDetails.departureDiversionAptCode = null;
    }


    if (!!vm.airCraftDetails.arrivalDiversionAirport) {
      vm.airCraftDetails.arrivalDiversionAirport = _.find(vm.airports, {airPortCode: vm.airCraftDetails.arrivalDiversionAirport})
    }
    else {
      vm.airCraftDetails.arrivalDiversionAirport = null;
    }

    vm.clickOnAtcAdhocSignEditIcon = function (){
      vm.atcAdhocSignIcon = !vm.atcAdhocSignIcon;
    };

    vm.updateAdHocAtcCallSign = function() {
      vm.atcAdhocSignIcon = !vm.atcAdhocSignIcon;
    };

    vm.filterValue = function(event){
      var keyCode = event.keyCode || event.which;

      //Regex for Valid Characters i.e. Alphabets and Numbers.
      var regex = /^[A-Za-z0-9]+$/;

      //Validate TextBox value against the Regex.
      var isValid = regex.test(String.fromCharCode(keyCode));
      if (!isValid) {
        event.preventDefault();
        MessageService.warning(MessageService.MESSAGES.FLIGHT.ATC_ADHOC_CALL_SIGN_CHARACTERS);
      }

      return isValid;
    };

    function findDefaultRadioValue() {
      var result = 'ATC-Ad-Hoc';
      if((vm.airCraftDetails.atcAdHocCallSign == null || vm.airCraftDetails.atcAdHocCallSign == '') && vm.airCraftDetails.atcCallSign != null && vm.airCraftDetails.atcCallSign != ''){
        result = 'ATC';
      }

      return result;
    }

    function updateAtcAdHocSign() {
      var result = true;
      if (vm.airCraftDetails.atcAdHocCallSign) {
        if(vm.atcAdHocCallSign != vm.airCraftDetails.atcAdHocCallSign) { //changed
          if(vm.airCraftDetails.atcAdHocCallSign.length == 4 ){
            var requestParams = {};
            requestParams.flightLegId = vm.airCraftDetails.flightLegId;
            requestParams.atcCallSign = vm.airCraftDetails.atcAdHocCallSign;
            requestParams.atcSignFlag = 'ADH';

            FlightWatch.updateAdHocAtcCallSign(requestParams, function (response) {
              if (response.success) {
                MessageService.success("AdHoc Atc Call Sign updated successfully  ");
                result = true;
              }
            }, function (error) {
              MessageService.error(error);
              result = false;
            });
          } else {
            MessageService.warning(MessageService.MESSAGES.FLIGHT.ATC_ADHOC_CALL_SIGN_LENGTH);
            result = false;
          }
        }
      } else { //delete
        if (vm.atcAdHocCallSign != null && vm.atcAdHocCallSign != "") { // initial value
          if (vm.airCraftDetails.atcAdHocCallSign == "" || vm.airCraftDetails.atcAdHocCallSign == null) {
            var requestParams = {};
            requestParams.flightLegId = vm.airCraftDetails.flightLegId;
            requestParams.atcCallSign = vm.airCraftDetails.atcAdHocCallSign;
            requestParams.atcSignFlag = 'ADH';

            FlightWatch.updateAdHocAtcCallSign(requestParams, function (response) {
              if (response.success) {
                MessageService.success("AdHoc Atc Call Sign deleted successfully  ");
                result = true;
              }
            }, function (error) {
              MessageService.error(error);
              result = false;
            });
          }
        }
      }
      return result;
    }

    vm.approachCondition = [
      {"approachConCode": "VMC"},
      {"approachConCode": "IMC"}
    ];

    vm.validationParam = {
      invalidActualNoOfAdults: false,
      invalidNoOfChildren: false,
      invalidNoOfInfants: false,
      invalidEstNoOfAdults: false,
      invalidEstNoOfChildren: false,
      invalidEstNoOfInfants: false,
      invalidPld: false,
      invalidFuelOBDep: false,
      invalidFuelUpLftDep: false,
      invalidSg: false,
      invalidMinFuel: false,
      invalidAppType: false,
      invalidAppCon: false,
      invalidLeakages: false,
      invalidDefueling: false,
      invalidExtraFuel: false

    };

    var delayCodeObj = function () {
      var delay = {"flightDelayReasonCode": '', "departureOrArrival": "", "delayTime": ""};
      return delay;
    };

    vm.updateFlyDuration = function(){
    	var flyDurationInMins = 0;
		if (!!vm.airCraftDetails.arrivalDiversionActualArrivalDate && !!vm.airCraftDetails.arrivalDiversionActualArrivalTime) {
				if (!!vm.airCraftDetails.landingDate && !!vm.airCraftDetails.landingTime) {	//when diversion and landing time exist
					if(!!vm.airCraftDetails.takeOffDate && !!vm.airCraftDetails.takeOffTime && !!vm.airCraftDetails.arrivalDiversionLandingDate && !!vm.airCraftDetails.arrivalDiversionTakeOffTime &&
							!!vm.airCraftDetails.arrivalDiversionTakeOffDate && !!vm.airCraftDetails.arrivalDiversionTakeOffTime){
						flyDurationInMins = (moment(vm.airCraftDetails.arrivalDiversionLandingDate + " " + vm.airCraftDetails.arrivalDiversionLandingTime, "DD/MM/YYYY HH:mm"))
							.diff(moment(vm.airCraftDetails.takeOffDate + " " + vm.airCraftDetails.takeOffTime , "DD/MM/YYYY HH:mm"), 'minutes')
							+ (moment(vm.airCraftDetails.landingDate + " " + vm.airCraftDetails.landingTime , "DD/MM/YYYY HH:mm")).diff(moment(vm.airCraftDetails.takeOffDate + " " + vm.airCraftDetails.takeOffTime , "DD/MM/YYYY HH:mm"), 'minutes') ;
					}

				} else if (!!vm.airCraftDetails.takeOffDate && !!vm.airCraftDetails.takeOffTime && !!vm.airCraftDetails.arrivalDiversionLandingDate && !!vm.airCraftDetails.arrivalDiversionLandingTime) {
						flyDurationInMins = (moment(vm.airCraftDetails.arrivalDiversionLandingDate + " "
								+ vm.airCraftDetails.arrivalDiversionLandingTime , "DD/MM/YYYY HH:mm")).diff(moment(vm.airCraftDetails.takeOffDate + " " + vm.airCraftDetails.takeOffTime , "DD/MM/YYYY HH:mm"), 'minutes');
				}

		} else if(!!vm.airCraftDetails.takeOffDate && !!vm.airCraftDetails.takeOffTime && !!vm.airCraftDetails.landingDate && !!vm.airCraftDetails.landingTime){
			flyDurationInMins = (moment(vm.airCraftDetails.landingDate + " " + vm.airCraftDetails.landingTime , "DD/MM/YYYY HH:mm")).diff(moment(vm.airCraftDetails.takeOffDate + " " + vm.airCraftDetails.takeOffTime , "DD/MM/YYYY HH:mm"), 'minutes');
		}
		vm.airCraftDetails.flyingDuration = CommonLogicService.getHoursByMinutes(flyDurationInMins || 0);
	}

    var delayData = vm.airCraftDetails.flightDelayReasons;
    var arrDelays = [];
    var depDelays = [];
    vm.totalDepDelays = 0 , vm.totalArrDelays = 0;

    vm.passengerInfo = {};
    vm.passengerInfo.actualNoOfAdults = vm.airCraftDetails.actualNoOfAdults || 0;
    vm.passengerInfo.actualNoOfChildren = vm.airCraftDetails.actualNoOfChildren || 0;
    vm.passengerInfo.actualNoOfInfants = vm.airCraftDetails.actualNoOfInfants || 0;
    vm.takeOffLandingInfo = {};
    vm.takeOffLandingInfo.takeOffCrewProfileId = vm.airCraftDetails.takeOffCrewProfileId;
    vm.takeOffLandingInfo.landingCrewProfileId = vm.airCraftDetails.landingCrewProfileId;

    angular.forEach(delayData, function (delay) {

      if (delay.departureOrArrival === 'DEP') {
        var tempDep = delayCodeObj();
        tempDep.flightDelayReasonCode = _.find(vm.delayCodeDetails, {delayCode: delay.delayReasonCode});
        tempDep.departureOrArrival = delay.departureOrArrival;
        tempDep.delayTime = delay.delayTime;
        depDelays.push(tempDep);
        vm.totalDepDelays = vm.totalDepDelays + delay.delayTime;
      }
      else if (delay.departureOrArrival === 'ARR') {
        var tempArr = delayCodeObj();
        tempArr.flightDelayReasonCode = _.find(vm.delayCodeDetails, {delayCode: delay.delayReasonCode});
        tempArr.departureOrArrival = delay.departureOrArrival;
        tempArr.delayTime = delay.delayTime;
        arrDelays.push(tempArr);
        vm.totalArrDelays = vm.totalArrDelays + delay.delayTime;
      }
    });

    vm.changeDepDelay = function () {
      vm.totalDepDelays = 0;
      angular.forEach(vm.depDelays, function (delay) {
        if (delay.delayTime) {

          if (isNaN(delay.delayTime)) {
            delay.delayTime = "";
            MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_29)
          }
          else {
            vm.totalDepDelays = parseInt(vm.totalDepDelays) + parseInt(delay.delayTime);
          }
        }

      });
    };

    vm.changeArrDelay = function () {
      vm.totalArrDelays = 0;
      angular.forEach(vm.arrDelays, function (delay) {

        if (delay.delayTime) {
          if (isNaN(delay.delayTime)) {
            delay.delayTime = "";
            MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_29)
          }
          else {
            vm.totalArrDelays = parseInt(vm.totalArrDelays) + parseInt(delay.delayTime);
          }

        }

      });
    };

    if (depDelays.length < 4) {
      var d = 4 - depDelays.length;
      var i = 0;

      while (i < d) {
        var depDel = delayCodeObj();
        depDel.departureOrArrival = 'DEP';
        depDelays.push(depDel);
        i++;
      }
    }
    if (arrDelays.length < 4) {
      var d = 4 - arrDelays.length;
      var i = 0;
      while (i < d) {
        var arrDel = delayCodeObj();
        arrDel.departureOrArrival = 'ARR';
        arrDelays.push(arrDel);
        i++;
      }
    }

    vm.depDelays = depDelays;
    vm.arrDelays = arrDelays;

    function getAirCraftTypes() {
      CommonMasterData.getAircraftTypeList(
        function (aircrafts) {
          vm.aircraftTypes = aircrafts;
        },
        function () {
          console.log('Aircraft type retrieval error');
        }
      );
    }

    vm.addNewdelay = function (delayType) {
      var delayObj = delayCodeObj();
      delayObj.departureOrArrival = delayType;
      if (delayType == "DEP") {
        depDelays.push(delayObj);
      }
      else if (delayType == "ARR") {
        arrDelays.push(delayObj);
      }
    };

    vm.validFlightRegistration = function(){
      return validateRegistrationId();
    };

    function validateMovementInfo() {
      //validate registration
      if (!validateRegistrationId()) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.ADD_CHECKS_2);
        return false;
      }

      var isValid = false;

      // if ATD != "" TOFF cannot be blank. there should be values for both or no values for both.
      var atdDate = vm.airCraftDetails.actualDepartureDate;
      var atdTime = vm.airCraftDetails.actualDepartureTime;
      var toffDate = vm.airCraftDetails.takeOffDate;
      var toffTime = vm.airCraftDetails.takeOffTime;
      var ataDate = vm.airCraftDetails.actualArrivalDate;
      var ataTime = vm.airCraftDetails.actualArrivalTime;
      var lndgDate = vm.airCraftDetails.landingDate;
      var lndgTime = vm.airCraftDetails.landingTime;

      /*TOFF  can not have values, if ATD doesnt have value*/
      if ((!!toffDate || !!toffTime) && (!!!atdDate || !!!atdTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_1);
        return false;
      }

      else if ((!!atdDate && !!atdTime) && (!!!toffDate|| !!!toffTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_2);
        return false;
      }

      // if LNDG != "" ATA cannot be blank. there should be values for both or no values for both.

      //*LND can not have values, if TOFF doesnt have value*//*
      else if ((!!lndgDate || !!lndgTime) && (!!!toffDate || !!!toffTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_2);
        return false;
      }

      //*ATA can not have values, if LND doesnt have value*//*
      else if ((!!ataDate || !!ataTime) && (!!!lndgDate || !!!lndgTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_4);
        return false;
      }


      else if ((!!lndgDate && !!lndgTime) && (!!!ataDate || !!!ataTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_3);
        return false;
      }

      // if ATA != "" LNDG cannot be blank. there should be values for both or no values for both.
      else if ((!!ataDate && !!ataTime) && (!!!lndgDate || !!!lndgTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_4);
        return false;
      }

      else {
        return validMovementInfoDateTimeFormat();
      }

    };

    function validateRegistrationId() {
      if (!!vm.airCraftDetails.currentRegId && !!vm.airCraftDetails.currentRegId.registrationID) {
        return true;
      } else if(!vm.airCraftDetails.previousRegId === null &&
        (vm.updateFlightSource === applicationConstants.UPDATE_FLIGHT_SOURCE.MANAGE_FLIGHT
          || vm.updateFlightSource === applicationConstants.UPDATE_FLIGHT_SOURCE.FLIGHT_PUNCTUALITY
          || vm.updateFlightSource === applicationConstants.UPDATE_FLIGHT_SOURCE.JOURNEY_LOG)){
        return true;
      } else {
        return false;
      }
    }

    function validMovementInfoDateTimeFormat() {
      var rstdDate = vm.airCraftDetails.estimatedDepartureDate;
      var rstdTime = vm.airCraftDetails.estimatedDepartureTime;
      var rstaDate = vm.airCraftDetails.estimatedArrivalDate;
      var rstaTime = vm.airCraftDetails.estimatedArrivalTime;
      var atdDate = vm.airCraftDetails.actualDepartureDate;
      var atdTime = vm.airCraftDetails.actualDepartureTime;
      var toffDate = vm.airCraftDetails.takeOffDate;
      var toffTime = vm.airCraftDetails.takeOffTime;
      var ataDate = vm.airCraftDetails.actualArrivalDate;
      var ataTime = vm.airCraftDetails.actualArrivalTime;
      var lndgDate = vm.airCraftDetails.landingDate;
      var lndgTime = vm.airCraftDetails.landingTime;

      if ((!!rstdDate && !dateValidDate(rstdDate)) || (!!rstdTime && !timeValidate(rstdTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_5);
        return false;
      }
      else if ((!!rstaDate && !dateValidDate(rstaDate)) || (!!rstaTime && !timeValidate(rstaTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_6);
        return false;
      }
      else if ((!!atdDate && !dateValidDate(atdDate)) || (!!atdTime && !timeValidate(atdTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_7);
        return false;
      }
      else if ((!!lndgDate && !dateValidDate(lndgDate)) || (!!lndgTime && !timeValidate(lndgTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_8);
        return false;
      }
      else if ((!!toffDate && !dateValidDate(toffDate)) || (!!toffTime && !timeValidate(toffTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_9);
        return false;
      }

      else if ((!!ataDate && !dateValidDate(ataDate)) || (!!ataTime && !timeValidate(ataTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_10);
        return false;
      }
      else {
        return validFlightTime();
      }

    }

    function validFlightTime() {

      //check ATD > ETD
      if (!!vm.airCraftDetails.actualDepartureDate && !!vm.airCraftDetails.actualDepartureTime
    		  && !!vm.airCraftDetails.originalEstimatedDepartureDate && !!vm.airCraftDetails.originalEstimatedDepartureTime) {

        var atd = moment(vm.airCraftDetails.actualDepartureDate + " " + vm.airCraftDetails.actualDepartureTime,"DD/MM/YYYY HH:mm");
        var etd = moment(vm.airCraftDetails.originalEstimatedDepartureDate + " " + vm.airCraftDetails.originalEstimatedDepartureTime,"DD/MM/YYYY HH:mm");

        if(etd.diff(atd, 'minutes') > 60) {
          var details = {
            title: 'Confirmation',
            messages: ["ATD is advanced by more than 60 minutes, are you sure you want to continue?"]

          };
          PopupManager.openModal('CONFIRM_DIALOG', details, validFlightTimeInDetail);
        }else if(atd.isBefore(etd)){

          var details = {
            title: 'Confirmation',
            messages: ["ATD < RSTD. Do you wish to continue?"]

          };
          PopupManager.openModal('CONFIRM_DIALOG', details, validFlightTimeInDetail);
        }else{
          return validFlightTimeInDetail('YES');
        }

      }
      else {
        return validFlightTimeInDetail('YES');
      }


    }

    function validFlightTimeInDetail(pass) {

      if(pass != 'YES'){
    	  return;
      }

      var atdDate = vm.airCraftDetails.actualDepartureDate;
      var atdTime = vm.airCraftDetails.actualDepartureTime;
      var toffDate = vm.airCraftDetails.takeOffDate;
      var toffTime = vm.airCraftDetails.takeOffTime;
      var ataDate = vm.airCraftDetails.actualArrivalDate;
      var ataTime = vm.airCraftDetails.actualArrivalTime;
      var lndgDate = vm.airCraftDetails.landingDate;
      var lndgTime = vm.airCraftDetails.landingTime;

      //check TOFF > ATD
      if (!!toffDate && !!toffTime && !!atdDate && !!atdTime
    		  && moment(toffDate + " " + toffTime).isBefore(atdDate + " " + atdTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_11);
        return false;
      }

      //check TOFF > LNDG
      else if (!!lndgDate && !!lndgTime && !!toffDate && !!toffTime &&
    		  moment(lndgDate + " " + lndgTime).isBefore(toffDate + " " + toffTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_12);
        return false;
      }

      //check ATA > LNDG
      else if (!!ataDate && !!ataTime  && !!lndgDate && !!lndgTime
    		  && moment(ataDate + " " + ataTime).isBefore(lndgDate + " " + lndgTime)) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_13);
        return false;
      }
      else {
        return validAtaSta()
      }

    }

    function validAtaSta() {
      //check ATA > STA
      if (!!vm.airCraftDetails.actualArrivalDate && !!vm.airCraftDetails.actualArrivalTime
    		  && !!vm.airCraftDetails.originalEstimatedArrivalDate && !!vm.airCraftDetails.originalEstimatedArrivalTime
    		  && moment(vm.airCraftDetails.actualArrivalDate + " " + vm.airCraftDetails.actualArrivalTime)
    		  .isBefore(vm.airCraftDetails.originalEstimatedArrivalDate + " " + vm.airCraftDetails.originalEstimatedArrivalTime)) {
        var details = {
          title: 'Confirmation',
          messages: ["ATA < STA . Do you wish to continue?"]

        };
        PopupManager.openModal('CONFIRM_DIALOG', details, validDelayCodes);
      }
      else {
        return validDelayCodes('YES')
      }
    }

    function validDelayCodes(pass) {

      if(pass != 'YES'){
       	  return;
      }

      var isValid = false;
      for (var i = 0; i < vm.depDelays.length; i++) {
        if (vm.depDelays[i].flightDelayReasonCode === " ") {
          vm.depDelays[i].flightDelayReasonCode = "";
        }
        if ((vm.depDelays[i].flightDelayReasonCode != "" && vm.depDelays[i].flightDelayReasonCode != undefined && vm.depDelays[i].delayTime === "")
          || ((vm.depDelays[i].flightDelayReasonCode === "" || vm.depDelays[i].flightDelayReasonCode == undefined) && vm.depDelays[i].delayTime != "")) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_14_D);
          isValid = false;
          break;

        }
        else {
          isValid = true;
        }
      }

      if (isValid) {
        return validArrivalDelay()
      }else{
    	  return isValid;
      }

    }

    function validArrivalDelay() {
      var isValid = false;
      for (var i = 0; i < vm.arrDelays.length; i++) {
        if (vm.arrDelays[i].flightDelayReasonCode === " ") {
          vm.arrDelays[i].flightDelayReasonCode = "";
        }
        if ((vm.arrDelays[i].flightDelayReasonCode != "" && vm.arrDelays[i].flightDelayReasonCode != undefined && vm.arrDelays[i].delayTime === "")
          || ((vm.arrDelays[i].flightDelayReasonCode === "" || vm.arrDelays[i].flightDelayReasonCode == undefined) && vm.arrDelays[i].delayTime != "") ) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_14_A);
          isValid = false;
          break;

        }
        else {
          isValid = true;
        }
      }

      if (isValid) {
        return validDepDelay();
      }else{
    	  return isValid;
      }

    }

    function validDepDelay() {
      var isValid = false;
      var errorMsg = "";
      //Please remove Departure delay reasons for the Departure delay (ATD - STD).
      if(!!vm.airCraftDetails.actualDepartureDate && !!vm.airCraftDetails.actualDepartureTime &&
    		  !!vm.airCraftDetails.originalEstimatedDepartureDate && !!vm.airCraftDetails.originalEstimatedDepartureTime ){
    	  var mm = moment(vm.airCraftDetails.actualDepartureDate + " " + vm.airCraftDetails.actualDepartureTime, "DD/MM/YYYY HH:mm")
    	  .diff(moment(vm.airCraftDetails.originalEstimatedDepartureDate + " " + vm.airCraftDetails.originalEstimatedDepartureTime, "DD/MM/YYYY HH:mm"));
          var d = moment.duration(mm);
          var actualDepDelay = d.asMinutes();

          if ((actualDepDelay > 0) && ((actualDepDelay < vm.totalDepDelays && vm.totalDepDelays !== "") || (actualDepDelay < vm.totalDepDelays && vm.totalDepDelays !== "" && vm.totalDepDelays > 0))) {
            MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_15);
            return false;

          }
          else if (actualDepDelay > vm.totalDepDelays && vm.totalDepDelays !== "" && actualDepDelay > 0) {
            MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_16);
            return false;
          }
      }


      return validArrDelay();

    }

    function validArrDelay() {
      var isValid = false;
      var errorMsg = "";

      if(!!vm.airCraftDetails.actualArrivalDate && !!vm.airCraftDetails.actualArrivalTime &&
    		  !!vm.airCraftDetails.originalEstimatedArrivalDate && !!vm.airCraftDetails.originalEstimatedArrivalTime){
    	//Please remove Departure delay reasons for the Departure delay (ATD - STD).
          var mm = moment(vm.airCraftDetails.actualArrivalDate + " " + vm.airCraftDetails.actualArrivalTime, "DD/MM/YYYY HH:mm")
          .diff(moment(vm.airCraftDetails.originalEstimatedArrivalDate + " " + vm.airCraftDetails.originalEstimatedArrivalTime, "DD/MM/YYYY HH:mm"));
          var d = moment.duration(mm);
          var actualDepDelay = d.asMinutes();

          if ((actualDepDelay > 0) && ((actualDepDelay < vm.totalArrDelays && vm.totalArrDelays !== '' && actualDepDelay >= 0) || (actualDepDelay < vm.totalArrDelays && vm.totalArrDelays !== '' && vm.totalArrDelays > 0))) {
            MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_17);
            return false;

          }
          else if (actualDepDelay > vm.totalArrDelays && vm.totalArrDelays !== '' && actualDepDelay > 0) {
            MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_18);
            return false;

          }
      }

      return diversionTimeValid();

    }

    function diversionTimeValid() {

      if(!!vm.airCraftDetails.arrivalDiversionAirport && !!vm.airCraftDetails.arrivalDiversionAirport.airPortCode){
  		  if(!(vm.airCraftDetails.continueDiversion || (!!vm.airCraftDetails.landingDate && !!vm.airCraftDetails.landingTime
  				  && !!vm.airCraftDetails.actualArrivalDate && !!vm.airCraftDetails.actualArrivalTime))){
  			MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_31);
            return false;
  		  }
  	  }
      //Diversion validation
      if (vm.airCraftDetails.continueDiversion) {

        var divAtdDate = vm.airCraftDetails.arrivalDiversionActualDepartureDate;
        var divAtdTime = vm.airCraftDetails.arrivalDiversionActualDepartureTime;
        var divLndgDate = vm.airCraftDetails.arrivalDiversionLandingDate;
        var divLndgTime = vm.airCraftDetails.arrivalDiversionLandingTime;
        var divToffDate = vm.airCraftDetails.arrivalDiversionTakeOffDate;
        var divToffTime = vm.airCraftDetails.arrivalDiversionTakeOffTime;
        var divAtaDate = vm.airCraftDetails.arrivalDiversionActualArrivalDate;
        var divAtaTime = vm.airCraftDetails.arrivalDiversionActualArrivalTime;
        var ataDate = vm.airCraftDetails.actualArrivalDate;
        var ataTime = vm.airCraftDetails.actualArrivalTime;


        // Arrival diversion info should be mandatory if arrival diversion airport is selected and check destination checked.
        if (!!!divAtdDate || !!!divAtdTime || !!!divLndgDate || !!!divLndgTime || !!!divToffDate || !!!divToffTime || !!!divAtaDate || !!!divAtaTime) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_19);
          return false;
        }


        else if (doDateTimeValidationDiversion() == false) {
          return false;
        }

        // check DIVATD > ATA
        else if ((!!ataDate && !!ataTime ) && (CheckDateTime(divAtdDate, divAtdTime, ataDate, ataTime))) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_20);
          return false;
        }

        //check DIVTakeOFF > DIVATD
        else if ((CheckDateTime(divToffDate, divToffTime, divAtdDate, divAtdTime))) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_21);
          return false;
        }

        //check DIVLnd > DIVTakeOFF
        else if ((CheckDateTime(divLndgDate, divLndgTime, divToffDate, divToffTime))) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_22);
          return false;
        }

        //check DIVATA > DIVLnd
        else if ((CheckDateTime(divAtaDate, divAtaTime, divLndgDate, divLndgTime))) {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_23);
          return false;
        }
        else if(!!!vm.airCraftDetails.departureDiversionAptCode){
    		MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_30);
            return false;
        }
        else {
        	validateAndUpdate();
        }

      }
      else {
        validateAndUpdate();
      }

    }

    function CheckDateTime(fromDate, fromTime, toDate, toTime) {
      return moment(fromDate + " " + fromTime).isBefore(toDate + " " + toTime);
    }

    function doDateTimeValidationDiversion() {
      var divAtdDate = vm.airCraftDetails.arrivalDiversionActualDepartureDate;
      var divAtdTime = vm.airCraftDetails.arrivalDiversionActualDepartureTime;
      var divLndgDate = vm.airCraftDetails.arrivalDiversionLandingDate;
      var divLndgTime = vm.airCraftDetails.arrivalDiversionLandingTime;
      var divToffDate = vm.airCraftDetails.arrivalDiversionTakeOffDate;
      var divToffTime = vm.airCraftDetails.arrivalDiversionTakeOffTime;
      var divAtaDate = vm.airCraftDetails.arrivalDiversionActualArrivalDate;
      var divAtaTime = vm.airCraftDetails.arrivalDiversionActualArrivalTime;


      if ((!!divLndgDate && !dateValidDate(divLndgDate)) || ((!!divLndgTime) && !timeValidate(divLndgTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_24);
        return false;
      }
      if ((!!divAtaDate && !dateValidDate(divAtaDate)) || (!!divAtaTime && !timeValidate(divAtaTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_25);
        return false;
      }
      if ((!!divAtdDate && !dateValidDate(divAtdDate)) || (!!divAtdTime && !timeValidate(divAtdTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_26);
        return false;
      }
      if ((!!divToffDate && !dateValidDate(divToffDate)) || (!!divToffTime && !timeValidate(divToffTime))) {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.MOVEMENT_ERROR_27);
        return false;
      }

      return true;
    }

    function dateValidDate(date) {
      var isValid = false;

      if (!!date) {
        var isValid = moment(date, 'DD/MM/YYYY', true).isValid();
      }
      return isValid;

    }

    function timeValidate(time) {
      var isValid = false;

      if (!!time) {
        var isValid = moment(time, 'HH:mm', true).isValid();
      }
      return isValid;
    }

    function validatePassengerInfo(){

      var isValid = true;

      if (vm.passengerInfoUpdate.$dirty) {
    	    if (!vm.passengerInfoUpdate.$valid  || vm.validationParam.invalidActualNoOfAdults
    	    		|| vm.validationParam.invalidNoOfChildren || vm.validationParam.invalidNoOfInfants) {
    	    	MessageService.warning("Invalid Passenger Information.");
    	    	isValid = false;
    	    }
       }

       return isValid;
    }

    function validateFuelInfo(){

    	var isValid = true;

        if (vm.fuelInfoUpdate.$dirty ) {
             if (!vm.fuelInfoUpdate.$valid || !validFuelContent()) {
            	 MessageService.warning("Invalid Fuel Information.");
            	 isValid = false;
             }
         }

        return isValid;
    }

    function validateTakeOfLanding(){

    	var isValid = true;

    	if (vm.takeOffLandingUpdate.$dirty) {
    	    if (!vm.takeOffLandingUpdate.$valid || !validTOffLandSelection()) {
    	    	 isValid = false;
    	    }
    	}

    	return isValid;
    }

    vm.updateFlightInfo = function(){
      // update atc adhoc call sign
      var result = updateAtcAdHocSign();

      if(result){
        var movementInfoValidity = validateMovementInfo();
      }
    };

    function validateAndUpdate(){
    	var passengerInfoValidity = validatePassengerInfo();
    	var fuelInfoValidity = validateFuelInfo();
    	var takeOffLandingValidity = validateTakeOfLanding();

    	if(passengerInfoValidity && fuelInfoValidity && takeOffLandingValidity){
    		var req = populateFlightUpdateRequest(false);
    		updateFlightInfo(req);
    	}
    }

    function populateFlightUpdateRequest(ignorePaxOverload){
//    	var movementInfoValidity = validateMovementInfo();
    	var passengerInfoValidity = validatePassengerInfo();
    	var fuelInfoValidity = validateFuelInfo();
    	var takeOffLandingValidity = validateTakeOfLanding();

    	var req = null;

    	if(passengerInfoValidity && fuelInfoValidity && takeOffLandingValidity){

    		req = { movementInfo :null, crewInfo :null,passengerInfo :null,fuelInfo :null };

    		if(vm.movementInfo.$dirty){
    			var returnFlightData = FlightWatch.getreturnFlightLegDetails(vm.airCraftDetails.flightLegId, vm.rotationData)
    		    var param = FlightWatch.mapMovementData(vm.airCraftDetails, vm.depDelays, vm.arrDelays, vm.newRemarks, returnFlightData);
    			req.movementInfo = param
    		}

    		if(vm.passengerInfoUpdate.$dirty && passengerInfoValidity){
    			var param = vm.passengerInfo;

    			param.actualNoOfAdults = parseInt(param.actualNoOfAdults);
    			param.actualNoOfChildren = parseInt(param.actualNoOfChildren);
    			param.actualNoOfInfants = parseInt(param.actualNoOfInfants);

    	        param.estimatedNoOfAdultsMale = vm.airCraftDetails.estimatedNoOfAdultsMale;
    	        param.estimatedNoOfChildren = vm.airCraftDetails.estimatedNoOfChildren;
    	        param.estimatedNoOfInfants = vm.airCraftDetails.estimatedNoOfInfants;
    	        param.flightLegId = vm.airCraftDetails.flightLegId;
    	        param.version = vm.airCraftDetails.version;
    	        param.ignorePaxOverCapcity = ignorePaxOverload;
    	        req.passengerInfo = param;
    		}

    		if(vm.fuelInfoUpdate.$dirty && fuelInfoValidity){
    			var param = populateUpdateFuelDetails();
    			req.fuelInfo = param;
    		}

    		if(vm.takeOffLandingUpdate.$dirty && takeOffLandingValidity){
    			var params = FlightWatch.populateUpdateTakeOffLandingDetails(vm.airCraftDetails, vm.takeOffLandingInfo);
    			req.crewInfo = params;
    		}

        req.isCheckConnectionFlight = 'N';

      }

    	return req;
    }

    function updateFlightInfo(req){
    	if(vm.movementInfo.$dirty || vm.passengerInfoUpdate.$dirty ||
				vm.fuelInfoUpdate.$dirty || vm.takeOffLandingUpdate.$valid) {
			FlightWatch.updateFlightInfo(req,
			    function (response) {
    	            if (response.success) {
                      if(response.movementResponse.flightConnectionInfo != null){
                        var missConnectionDetail = "["
                        angular.forEach(response.movementResponse.flightConnectionInfo.flightMisconnections, function (misscon) {
                          missConnectionDetail = missConnectionDetail + "{Connection flight Number : " + misscon.connectionFlightNumber + ", Connection Type : "+misscon.connectionType + ", PAX : "+parseInt(misscon.pax)+"}";
                        });

                        missConnectionDetail = missConnectionDetail+"]"

                        req.isCheckConnectionFlight = 'Y';
                        var details = {
                          title: 'Confirmation',
                          messages: ["Miss Connections " + missConnectionDetail + " exist , are you sure you want to continue?"],
                        };

                        PopupManager.openModal('CONFIRM_DIALOG', details, confirmAfterSeeingMissconnectionFlight);
                      }

                    updateMovementInfoCallBack(response.movementResponse,req.movementInfo);
    	            	updatePassengerInfoCallBack(response.passengerInforResponse);
                    updateFuleInfoCallBack(response.saveFuelInfoResponse);
                    updateCrewInfoCallBack(response.crewInfo);
    	            }else{
    	            	if(response.paxExceedCapcity){
  	            		  var details = {
  	                              title: 'Confirmation',
  	                              messages: ["Total Pax (" + (parseInt(vm.passengerInfo.actualNoOfAdults) + parseInt(vm.passengerInfo.actualNoOfChildren)) + ") exceeds the A/C capacity , are you sure you want to continue?"]

  	                      };
  	                      PopupManager.openModal('CONFIRM_DIALOG', details, onCloseAndExceedCapacity);
    	            	}
    	            }
	            },
	            function (response) {
	            	 MessageService.warning(response[0]);
	            });
		}
    }

    function updateMovementInfoCallBack(response,param){
    	if (response && response.success) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.UPDATE_FLIGHT_DETAILS.UPDATE_FLIGHT, param);
            vm.airCraftDetails.version = response.version;
            //reassign
            vm.airCraftDetails.previousRegId = vm.airCraftDetails.currentRegId;

            // update amadeus flag
            checkAircraftRegistrationUpdateStatus();

            MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.UPDATE_FLIGHT_DETAILS.UPDATE_ROTATION);
            vm.newRemarks = [];
    	}
    }

    function updatePassengerInfoCallBack(response){
    	if(response && response.success){
    		if(response.version > vm.airCraftDetails.version){
        		vm.airCraftDetails.version = response.version;
        	}
    		if(!response.paxSaved){
          MessageService.warning(MessageService.MESSAGES.FLIGHT.ACTUAL_PAX_ALREADY_UPATED_FROM_SOURCE);
        }else {
          MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
        }
    	}

    }

    function updateFuleInfoCallBack(response){
    	if (response && response.success) {
    		if(response.version > vm.airCraftDetails.version){
    			vm.airCraftDetails.version = response.version;
    		}
            MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
        }
    }

    function updateCrewInfoCallBack (response) {
        if (response && response.success) {
	        var aircraftVersion = parseInt(vm.airCraftDetails.version) + 1;
	        vm.airCraftDetails.version = aircraftVersion;
	        MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
        }
    }

    function updateMovementInfo() {
      var temp = vm.airCraftDetails;
//            if (vm.movementInfo.$dirty) {
      if (vm.movementInfo.$valid) {

        var returnFlightData = FlightWatch.getreturnFlightLegDetails(vm.airCraftDetails.flightLegId, vm.rotationData)
        var param = FlightWatch.mapMovementData(vm.airCraftDetails, vm.depDelays, vm.arrDelays, vm.newRemarks, returnFlightData);
        FlightWatch.updateFlightDetails(param,
          function (response) {
            if (response.success) {
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.UPDATE_FLIGHT_DETAILS.UPDATE_FLIGHT, param);
              vm.airCraftDetails.version = response.version;
              MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.UPDATE_FLIGHT_DETAILS.UPDATE_ROTATION);
              vm.newRemarks = [];
            }
          },
          function (response) {
            MessageService.warning(response[0]); // response.error
            console.log('Update movement info error');
          })
      }
//            }
//            else {
//                MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_FORM_NOT_TOUCH);
//            }
    }

    vm.updatePassengerInfo = function () {

      if (vm.passengerInfoUpdate.$dirty) {
        if (vm.passengerInfoUpdate.$valid && !vm.validationParam.invalidActualNoOfAdults && !vm.validationParam.invalidNoOfChildren && !vm.validationParam.invalidNoOfInfants) {

          var param = vm.passengerInfo;
          param.estimatedNoOfAdultsMale = vm.airCraftDetails.estimatedNoOfAdultsMale;
          param.estimatedNoOfChildren = vm.airCraftDetails.estimatedNoOfChildren;
          param.estimatedNoOfInfants = vm.airCraftDetails.estimatedNoOfInfants;

          param.estimatedNoOfAdultsMale = vm.airCraftDetails.estimatedNoOfAdultsMale;
          param.estimatedNoOfChildren = vm.airCraftDetails.estimatedNoOfChildren;
          param.estimatedNoOfInfants = vm.airCraftDetails.estimatedNoOfInfants;

          param.flightLegId = vm.airCraftDetails.flightLegId;
          param.version = vm.airCraftDetails.version;
          param.ignorePaxOverCapcity = false;
          FlightWatch.updatePassengerDetails(param,
            function (response) {
              if (response.success) {
                vm.airCraftDetails.version = response.version;
                MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
              }
              else if (response.paxExceedCapcity) {
                var details = {
                  title: 'Confirmation',
                  messages: ["Total Pax (" + (parseInt(vm.passengerInfo.actualNoOfAdults) + parseInt(vm.passengerInfo.actualNoOfChildren)) + ") exceeds the A/C capacity , are you sure you want to continue?"]

                };
                PopupManager.openModal('CONFIRM_DIALOG', details, onCloseAndExceedCapacity);
              }
            },
            function () {
              console.log('Update passenger error');
            })
        }
      }
      else {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_FORM_NOT_TOUCH);
      }
    };

    function onCloseAndExceedCapacity(param) {
      if (!!param) {
    	var req = populateFlightUpdateRequest(true);
  		updateFlightInfo(req);
      }
    }

    function confirmAfterSeeingMissconnectionFlight(param) {
      if (!!param) {
        var req = populateFlightUpdateRequest(true);
        req.isCheckConnectionFlight = 'Y';
        updateFlightInfo(req);
      }
    }

    vm.closeUpdatePopUp = function () {
      $uibModalInstance.close(modalParams.close);
    };

    // cancel flight using flightLegId
    vm.cancelOrReInstateFlight = function () {

      if(vm.airCraftDetails.landingDate != null || vm.airCraftDetails.takeOffDate != null) {
        updateFlightAsCancel();
      } else if(vm.airCraftDetails.remarks == null || vm.airCraftDetails.remarks.length === 0) {
        displayRemarkRequiredMessage();
      } else {
        updateFlightAsCancel();
      }
    };

    function displayRemarkRequiredMessage() {

      var details = {
        title: 'Enter Remark',
        messages: ["Please provide a remark for flight cancellation"]
      };
      PopupManager.openModal('CANCEL_FLIGHT_DIALOG', details);

    }

    function updateFlightAsCancel() {

      var param = {'flightLegId': vm.airCraftDetails.flightLegId, 'flightLegStatus':vm.airCraftDetails.flightLegStatus};
      FlightWatch.cancelOrReInstateFlight(param,
        function (response) {
          $uibModalInstance.close(vm.airCraftDetails.flightLegId);
          if (response.success) {

            MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_CANCEL_OR_REINSTATE_SUCCESS);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.UPDATE_FLIGHT_DETAILS.CANCEL_FLIGHT, param);
          }
        },
        function (error) {
          MessageService.warning(error[0]);
        })

    }

    function getFlightAssignedCrew() {
      FlightWatch.loadFlightAssignedCrew(vm.airCraftDetails.flightLegId,
        function (response) {
          vm.airCraftDetails.assignedCrew = response;
        },
        function () {
          console.log('load flight assigned crew error');
        })
    }

    function populateUpdateFuelDetails() {
        if (vm.airCraftDetails.approachConditionTemp === undefined) {
          vm.airCraftDetails.approachConditionTemp = {approachTypeCode: ''};
        }

        if (vm.airCraftDetails.approachTypeTemp === undefined) {
          vm.airCraftDetails.approachTypeTemp = {approachConCode: ''};
        }

        if (vm.airCraftDetails.fuelSupplierTemp === undefined) {
          vm.airCraftDetails.fuelSupplierTemp = {fuelSupplierId: ''};
        }

        if (vm.fuelInfoUpdate.$dirty || (!!vm.airCraftDetails.landingDate) || (vm.airCraftDetails.approachTypeTemp.approachConCode !== '' )
          || (vm.airCraftDetails.approachConditionTemp.approachTypeCode !== '' )) {
          /*if (vm.airCraftDetails.fuelSupplierTemp.fuelSupplierId !== '') {*/
            if (vm.fuelInfoUpdate.$valid && validFuelContent()) {
              var param = FlightWatch.mapFuelData(vm.airCraftDetails, vm.depDelays, vm.arrDelays);
              return param;
            }
          /*} else {
            MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUPPLIER_EMPTY);
          }*/

        }
        else {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_FORM_NOT_TOUCH);
        }
    }

    vm.updateFuelDetails = function () {
      if (vm.airCraftDetails.approachConditionTemp === undefined) {
        vm.airCraftDetails.approachConditionTemp = {approachTypeCode: ''};
      }

      if (vm.airCraftDetails.approachTypeTemp === undefined) {
        vm.airCraftDetails.approachTypeTemp = {approachConCode: ''};
      }

      if (vm.airCraftDetails.fuelSupplierTemp === undefined) {
        vm.airCraftDetails.fuelSupplierTemp = {fuelSupplierId: ''};
      }

      if (vm.fuelInfoUpdate.$dirty || (!!vm.airCraftDetails.landingDate) || (vm.airCraftDetails.approachTypeTemp.approachConCode !== '' )
        || (vm.airCraftDetails.approachConditionTemp.approachTypeCode !== '' )) {
        /*if (vm.airCraftDetails.fuelSupplierTemp.fuelSupplierId !== '') {*/
          if (vm.fuelInfoUpdate.$valid && validFuelContent()) {
            var param = FlightWatch.mapFuelData(vm.airCraftDetails, vm.depDelays, vm.arrDelays);
            FlightWatch.updateFuelDetails(param,
              function (response) {
                if (response.success) {
                  vm.airCraftDetails.version = response.version;
                  MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
                }
              },
              function (error) {
                MessageService.warning(error[0]);
              })
          }
        /*} else {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUPPLIER_EMPTY);
        }*/

      }
      else {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_FORM_NOT_TOUCH);
      }
    };

    vm.updateTakeOffLandingInfo = function () {
      if (vm.takeOffLandingUpdate.$dirty) {
        if (vm.takeOffLandingUpdate.$valid && validTOffLandSelection()) {

          FlightWatch.updateTakeOffLandingDetails(vm.airCraftDetails, vm.takeOffLandingInfo,
            function (response) {
              if (response.success) {
                vm.airCraftDetails.version = parseInt(vm.airCraftDetails.version) + 1;
                MessageService.success(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_SUCCESS);
              }
            },
            function () {
              console.log('update flight error');
            })
        }
      }
      else {
        MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_FORM_NOT_TOUCH);
      }
    };

    vm.isNumeric = function (value, param) {
      if(value && param){
        vm.validationParam[param] = isNaN(value) || value < 0;
      }
    };

    vm.isNumericInteger = function (value, param) {
      if(value && param) {
        vm.validationParam[param] = isNaN(value) || value < 0 || !Number.isInteger(parseFloat(value));
      }
    };

    function validFuelContent() {
      var isValid = true;

      if (!!vm.airCraftDetails.landingDate && !!vm.airCraftDetails.landingTime) {
        //TODO need to validate landingDate and landingTime

        if (vm.airCraftDetails.approachTypeTemp.approachConCode === "") {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_APPROACH_CON_EMPTY);
          isValid = false;
          return isValid;
        }

        if (vm.airCraftDetails.approachConditionTemp.approachTypeCode === "") {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_APPROACH_TYPE_EMPTY);
          isValid = false;
          return isValid;
        }
      } else {
        if (vm.airCraftDetails.approachTypeTemp && vm.airCraftDetails.approachTypeTemp.approachConCode !== "") {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_APPROACH_TYPE_ONLY);
          isValid = false;
          return isValid;
        }

        if (vm.airCraftDetails.approachConditionTemp && vm.airCraftDetails.approachConditionTemp.approachTypeCode !== "") {
          MessageService.warning(MessageService.MESSAGES.FLIGHT.UPDATE_FLIGHT_APPROACH_CON_ONLY);
          isValid = false;
          return isValid;
        }
      }


      if (vm.validationParam.invalidPld ||
        vm.validationParam.invalidFuelOBDep ||
        vm.validationParam.invalidFuelUpLftDep ||
        vm.validationParam.invalidSg ||
        vm.validationParam.invalidMinFuel ||
        vm.validationParam.invalidAppType ||
        vm.validationParam.invalidAppCon ||
        vm.validationParam.invalidLeakages ||
        vm.validationParam.invalidDefueling ||
        vm.validationParam.invalidExtraFuel) {
        isValid = false;
        return isValid;

      }
      return isValid;
    }

    function validTOffLandSelection() {
      var isValid = true;
      if (vm.airCraftDetails.actualDepartureDate === null || vm.airCraftDetails.actualDepartureDate === '' || vm.airCraftDetails.actualArrivalDate === null || vm.airCraftDetails.actualArrivalDate === '') {
        isValid = false;
        MessageService.warning(MessageService.MESSAGES.FLIGHT.ATA_ATD_NULL);
      }
      return isValid;
    }

    vm.enableDiversion = function () {
      if(!!vm.airCraftDetails.continueDiversion ){
    	  vm.airCraftDetails.isDisableDiversion = false;
      } else {
    	  vm.airCraftDetails.isDisableDiversion = true;
    	  clearDiversionValues();
      }
      vm.updateFlyDuration();
    };

    function clearDiversionValues(){
    	vm.airCraftDetails.arrivalDiversionActualDepartureDate = null;
    	vm.airCraftDetails.arrivalDiversionActualDepartureTime = "";
    	vm.airCraftDetails.arrivalDiversionLandingTime = "";
    	vm.airCraftDetails.arrivalDiversionLandingDate = null;
    	vm.airCraftDetails.arrivalDiversionTakeOffDate = null;
    	vm.airCraftDetails.arrivalDiversionTakeOffTime = "";
    	vm.airCraftDetails.arrivalDiversionActualArrivalTime = "";
    	vm.airCraftDetails.arrivalDiversionActualArrivalDate = null;
    }

    function isContinueDiversion(){
    	if(!!vm.airCraftDetails.arrivalDiversionActualDepartureDate ||
    	!!vm.airCraftDetails.arrivalDiversionActualDepartureTime ||
    	!!vm.airCraftDetails.arrivalDiversionLandingTime   ||
    	!!vm.airCraftDetails.arrivalDiversionLandingDate   ||
    	!!vm.airCraftDetails.arrivalDiversionTakeOffDate  ||
    	!!vm.airCraftDetails.arrivalDiversionTakeOffTime  ||
    	!!vm.airCraftDetails.arrivalDiversionActualArrivalTime  ||
    	!!vm.airCraftDetails.arrivalDiversionActualArrivalDate){
    		return true;
    	}
    	return false;
    }

    vm.addRemarks = function () {
      if (vm.remark.trim() !== '') {
        vm.newRemarks.push(vm.remark);
        vm.remark = '';
      }
    };

    vm.updateRelatedAircraftList = function () {
      FlightWatch.loadAircraftListByCode(vm.airCraftDetails.aircraftModel.modelNumber,
        function (response) {
          vm.tempRelatedAirCraft = response;
          validateRegList(vm.airCraftDetails.estimatedDepartureDate, vm.airCraftDetails.estimatedArrivalDate, vm.tempRelatedAirCraft);
          vm.airCraftDetails.currentRegId = ''
        },
        function () {
          console.log('AirCraft loading error');
        })
    };

    vm.updateRSTATime = function () {
      if (vm.airCraftDetails.estimatedDepartureDate !== undefined && vm.airCraftDetails.estimatedDepartureTime !== undefined) {
        var tempDate = moment(vm.airCraftDetails.estimatedDepartureDate + " " + vm.airCraftDetails.estimatedDepartureTime, "DD/MM/YYYY HH:mm");
        var tempRSTD = moment(tempDate).add(vm.airCraftDetails.flightDurationInMinutes, 'minutes');
        vm.airCraftDetails.estimatedArrivalDate = tempRSTD.format('DD/MM/YYYY');
        vm.airCraftDetails.estimatedArrivalTime = tempRSTD.format('HH:mm');
      }
      validateRegList(vm.airCraftDetails.estimatedDepartureDate, vm.airCraftDetails.estimatedArrivalDate, vm.tempRelatedAirCraft);
    };

    vm.updateRegistration = function () {
      vm.movementInfo.$dirty = true;
      vm.airCraftDetails.regUpdated = true;
    };

    vm.onDepDelayTimeChange = function (index, delayReason) {
      vm.movementInfo.$dirty = true;
      if (delayReason === undefined || delayReason === ' ') {
        vm.depDelays[index].flightDelayReasonCode = '';
      }
    };

    vm.onArrDelayTimeChange = function (index, delayReason) {
      vm.movementInfo.$dirty = true;
      if (delayReason === undefined || delayReason === ' ') {
        vm.arrDelays[index].flightDelayReasonCode = '';
      }
    };

    vm.onSelectFuelInfo = function () {
      vm.fuelInfoUpdate.$dirty = true;
    }

    loadFuelReasonsForExtra();

    function loadFuelReasonsForExtra() {
      FlightWatch.loadExtraFuelReasons(
        function (response) {
          vm.extraFuelReasons = response;
        },
        function (response) {
        }
      )
    }
    loadSuppliers();

    function loadSuppliers() {
      //to load the fuel suppliers
      var params = {};
      params.cities = [vm.airCraftDetails.originApt] || null;
      params.status = 'ACT';
      params.flightDepartureDateString = vm.airCraftDetails.originalEstimatedDepartureDate;

      FlightWatch.getFuelSuppliersForFuelUplift(params,
        function (response) {
          vm.fuelSupplies = response;
        },
        function (response) {
        }
      );
      //Load fuel details
      var fuelParams = {
        flightLegId: vm.airCraftDetails.flightLegId
      };
      FlightWatch.loadUpdateFlightDetails(fuelParams,
        function (response) {
          vm.airCraftDetails = FlightWatch.updatedFlightDetails(vm.airCraftDetails, response);

          //Update select components
          if (!!vm.airCraftDetails.approachCondition) {
            vm.airCraftDetails.approachConditionTemp = _.find(vm.approachTypes, {approachTypeCode: vm.airCraftDetails.approachCondition});
          }
          if (!!vm.airCraftDetails.approachType) {
            vm.airCraftDetails.approachTypeTemp = _.find(vm.approachCondition, {approachConCode: vm.airCraftDetails.approachType});
          }

          if (!!vm.airCraftDetails.fuelSupplierId) {
            vm.airCraftDetails.fuelSupplierTemp = _.find(vm.fuelSupplies, {fuelSupplierId: vm.airCraftDetails.fuelSupplierId});
          }
        },
        function (error) {
        }
      );
    }

    vm.updateReg = function (departureDate, arrivalDate, aircraftList) {
      validateRegList(departureDate, arrivalDate, aircraftList);
    };

    function validateRegList(departureDate, arrivalDate, aircraftList) {
      var tempList = aircraftList;
      var tempAircraftList = [];
      if (departureDate && arrivalDate) {
        var from = convertToDate(departureDate);
        var to = convertToDate(arrivalDate);
        if (from <= to) {
          for (var i = 0; i < tempList.length; i++) {
            if (tempList[i].inactiveStartDate && tempList[i].inactiveEndDate) {
              var inactiveStart = convertToDate(tempList[i].inactiveStartDate);
              var inactiveEnd = convertToDate(tempList[i].inactiveEndDate);

              if (!(((inactiveStart <= to) && (inactiveStart >= from)) || ((inactiveEnd <= to) && (inactiveEnd >= from)) || ((inactiveStart <= from) && (to <= inactiveEnd)))) {
                tempAircraftList.push(tempList[i]);
              }
            } else {
              tempAircraftList.push(tempList[i]);
            }
          }
          vm.relatedAirCraft = tempAircraftList;
        }
      }
    }

    function convertToDate(dateStr) {
      var parts = dateStr.split("/");
      return new Date(parts[2], parts[1] - 1, parts[0]);
    }

    (function () {
      var searchRequest = '{"appParameterDesc" : "" }';
      CommonMasterData.loadAppParamList(searchRequest,
        function (paramList) {
          var appParam = paramList.appParamGroupMap.GENERAL;
          angular.forEach(appParam, function (patternParam) {
            if (patternParam.paramKey === 'ENABLE_PAX_EDIT') {
              vm.editDisablePax = patternParam.paramValue === 'Y' ? false : true;
            }
          });
        },
        function (error) {
          MessageService.error(error);
        });
    })();

    initiallySetDiversion();

    function checkFlightEditPriviExist() {
      CommonMasterData.getFlightEditPriviledge(
        function (response) {
          vm.flightEditPriviledges = response;
        },
        function () {
          console.log('Flight Edit Priviledge retrieval error');
        }
      );
    }

    function initiallySetDiversion(){
    	vm.enableDiversion();
    }

    //get raw slot message
    function loadSlotData() {
      RemoteService.loadSlotMessageByFlightLeg(vm.airCraftDetails.flightLegId).then(
        function (response) {
          vm.slotData = response.slotProcessedMessageDTOS;
        },
        function (error) {

        }
      );
    }

    //get mvt message data
    function loadMVTMessageData() {
      RemoteService.loadMVTMessageByFlightLeg(vm.airCraftDetails.flightLegId).then(
        function (response) {
          vm.mvtMessageData = response.mvtMessageDTOS;
        },
        function (error) {
          console.log(error);
        }
      );
    }

    function isShowMVTMessage() {
      CommonMasterData.isShowMVTMessage(function(response) {
        vm.isShowMVTMessage = response;
      }, function(error) {
        MessageService.error(error);
      });
    }

    vm.isMVTMsgEmpty = function () {
      var result = false;
      if (vm.mvtMessageData != null) {
        result = Object.keys(vm.mvtMessageData).length === 0;
      }
      return result;
    };

    vm.getSlotDataViewCollapse = function (index, value) {
      vm.slotRawDataIsCollapse[index] = !value;
    };

    vm.isObjectEmpty = function () {
      var result = false;
      if (vm.slotData != null) {
        result = Object.keys(vm.slotData).length === 0;
      }
      return result;
    };

    vm.makeLowerCase = function (string) {
      return string
        .split('_').join(' ')
        .toLowerCase()
        .replace(/(^| )(\w)/g, function (x) {
          return x.toUpperCase();
        });
    };

    vm.checkOriginalAndestimatedDepartureTimeDifference = function () {
      if ((vm.airCraftDetails.estimatedDepartureTime) != (vm.airCraftDetails.originalEstimatedDepartureTime)) {
        return true;
      }
      else {
        return false;
      }
    }

    function checkAircraftRegistrationUpdateStatus() {
      var request = getAircraftRegistrationUpdateStatusRequest(vm.airCraftDetails);
      FlightWatch.checkAircraftRegistrationUpdateStatus(request, function(response) {
        vm.amadeusServiceEnabled = response.enabled;
        vm.amadeusRegUpdated = response.identifier && vm.airCraftDetails.currentRegId.registrationID === response.acRegId;
      }, function(error) {
        MessageService.error(error);
      });
    }

    function getAircraftRegistrationUpdateStatusRequest(searchCriteria) {
      var req = {};
      req.flightNumber = searchCriteria.flightNo;
      req.departureDate = searchCriteria.estimatedDepartureDate;
      req.boardPoint = searchCriteria.originApt;

      return req;
    }

    vm.amadeusAircraftRegistrationSubmit = function () {
      var request = getAmadeusAircraftRegistrationSubmitRequest(vm.airCraftDetails);
      FlightWatch.amadeusAircraftRegistrationSubmit(request, function(response) {
        // update amadeus flag
        checkAircraftRegistrationUpdateStatus();
        MessageService.success('Successfully updated the amadeus Aircraft Registration Number!');
      }, function(error) {
        MessageService.error(error);
      });
    };

    function getAmadeusAircraftRegistrationSubmitRequest(searchCriteria) {
      var req = {};
      req.flightLegId = searchCriteria.flightLegId;
      req.flightNumber = searchCriteria.flightNo;
      req.origin = searchCriteria.originApt;
      req.destination = searchCriteria.destinationApt;
      req.estimatedDepartureDateStr = searchCriteria.estimatedDepartureDate;
      req.aircraftRegId = searchCriteria.currentRegId.registrationID;

      return req;
    }

    (function() {
      // load airport list
      CommonMasterData.getFlightOperationTypes(function(operationTypes) {
        vm.operationTypes = operationTypes;
      }, function(error) {
        console.log('Operation Types retrieval error!!!');
      });

    })();
  }

}());
